import { Entry } from 'contentful';
import { ILandingPageFields } from '../../../types/@types/generated/contentful';

type Props = {
  page: Entry<ILandingPageFields>;
  settings?: Record<string, unknown>;
};

const pageToCompatibleProps = ({ page, settings }: Props) => {
  const { affiliateName, affiliateDetails } = page.fields;
  return {
    affiliateName: affiliateName || (settings?.affiliateName as string | undefined),
    affiliateDetails,
    initiator: getInitiator({ page, settings }),
    campaignTag: page.fields.campaignTag || (settings?.tag as string | undefined),
    prioritizedImpacterIds:
      page.fields.prioritizedImpacterIds?.map((id) => Number(id)) ||
      (settings?.prioritizedImpacterIds as number[]),
    donationProgramId: page.fields.donationProgramId,
  };
};

const getInitiator = ({ page, settings }: Props) =>
  (settings?.initiator as string) ||
  page.fields.donationInitiator ||
  page.fields.tags?.join(' ') ||
  page.fields.slug;

export default pageToCompatibleProps;
